"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioButtonDisplayConditionDocument = exports.multiSelectDisplayConditionDocument = exports.dropdownDisplayConditionDocument = void 0;
var baseDocument_1 = require("./baseDocument");
var util_1 = require("../util");
exports.dropdownDisplayConditionDocument = util_1.prependQuestionToForm(util_1.configureQuestion("DROP_DOWN"), baseDocument_1.baseDocument);
exports.multiSelectDisplayConditionDocument = util_1.prependQuestionToForm(util_1.configureQuestion("MULTI_SELECT"), baseDocument_1.baseDocument);
exports.radioButtonDisplayConditionDocument = util_1.prependQuestionToForm(util_1.configureQuestion("RADIO_BUTTONS"), baseDocument_1.baseDocument);
//# sourceMappingURL=completeDocuments.js.map